import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// After authorization when separate browser router change pathname on /login real pathname can be different
export function useLocationSync() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname !== window.location.pathname) {
      navigate(pathname);
    }
  }, [navigate, pathname]);
}
